module.exports = __webpack_public_path__ + "img/news21-0.fb15c83c.png";